import _ from "lodash";
import employeeActions from "../../../actions/employeeActions";
import { getAccessProfile } from "../../../reducers/sessionReducer";
import sortObjectsArrayByProperty from "../../../utils/sortObjectsArrayByProperty";

const assetSpreadsheetInputFields = (formValues, dispatch, state) => {
  const fields = [
    {
      name: "headersLine",
      label: "Linha dos cabeçalhos",
      width: 180,
    },
    {
      name: "sheetName",
      label: "Nome da aba",
      width: 180,
    },
    {
      name: "file",
      label: "Arquivo de planilha",
      type: "file",
    },
    {
      name: "isPensionFund",
      label: "São fundos de previdência?",
      type: "checkbox",
      width: 150,
    },
    {
      name: "headers",
      label: "Cabeçalhos",
      type: "group",
      fields: [
        { name: "name", label: "Fundo", width: 200 },
        { name: "cgeCode", label: "Código CGE", width: 200 },
        { name: "cnpj", label: "CNPJ", width: 200 },
        { name: "segment", label: "Segmento", width: 200 },
        { name: "category", label: "Categoria BTG", width: 200 },
        { name: "subcategory", label: "Subcategoria BTG", width: 200 },
        { name: "isin", label: "ISIN", width: 200 },
        { name: "topFunds", label: "Top Funds", width: 200 },
        { name: "currency", label: "Moeda", width: 200 },
        { name: "suitabilityBtg", label: "Suitability BTG", width: 200 },
        { name: "management", label: "Gestão", width: 200 },
        { name: "targetAudience", label: "Público Alvo", width: 200 },
        {
          name: "openForSubscription",
          label: "Aberto para Captação",
          width: 200,
        },
        { name: "investmentPermitted", label: "Aplicação", width: 200 },
        { name: "minimumInvestment", label: "Aplicação Minima", width: 200 },
        { name: "minimumMovement", label: "Movimentação Minima", width: 200 },
        { name: "minimumBalance", label: "Saldo Minimo", width: 200 },
        {
          name: "liquidity",
          label: "Liquidez (Cotização + Liquidação dos Recursos Resgatados) D+",
          width: 200,
        },
        { name: "return36mCdi", label: "Retorno % do CDI - 36 M", width: 200 },
        { name: "return12m", label: "Retorno Nominal - 12 M", width: 200 },
        { name: "return24m", label: "Retorno Nominal - 24 M", width: 200 },
        { name: "return36m", label: "Retorno Nominal - 36 M", width: 200 },
        { name: "volatility12m", label: "Volatilidade 12 M", width: 200 },
        { name: "sharpe12m", label: "Sharpe 12M", width: 200 },
        { name: "beta12m", label: "Beta 12 M", width: 200 },
        { name: "anbimaClass", label: "Classificação Anbima", width: 200 },
        { name: "cvmClass", label: "Classificação CVM", width: 200 },
        { name: "netWorth", label: "Patrimônio Líquido", width: 200 },
        { name: "roaAdm", label: "RoA Adm", width: 200 },
        { name: "roaPerf", label: "RoA Perf", width: 200 },
      ],
    },
  ];

  if (getAccessProfile(state) === "Gestor") {
    fields.unshift({
      name: "assessorId",
      label: "Assessor",
      type: "object-select",
      meta: { valueKey: "id", labelKey: "name" },
      options: [],
      async: {
        fetch: () => dispatch(employeeActions.fetchAll()),
        fetchDelay: 500,
        mapSuccessfulResult: (response) =>
          sortObjectsArrayByProperty(
            Object.values(response.data.entities.employees),
            "name"
          ),
        mapProps: ({ response, ...others }) => ({
          ...others,
          options: response,
        }),
      },
      width: 320,
    });
  } else {
    _.remove(fields, (field) => field.name !== "file");
  }
  return fields;
};

export default assetSpreadsheetInputFields;
